import { Box, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import ThemeBtn from "../../Common/ThemeBtn";
import Context from "../../context";

// ----------------------------------------------------------------------

export default function ErrorMessage() {
	const { theme } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack sx={{ alignItems: "center", flex: 1 }} justifyContent={"center"}>
			<Image src='/ilustrations/bug_fixing_pana.svg' sx={{ width: { xs: 200, sm: 300 } }} />
			<Box sx={{ maxWidth: 700, margin: "auto", textAlign: "center", mt: { xs: 1, sm: 4 } }}>
				<Typography paragraph variant={isMobile ? "h4" : "h3"} color={theme?.colors.primaryText}>
					{translate("importing.error_title")}
				</Typography>
				<Typography color={theme?.colors.secondaryText} variant={isMobile ? "body2" : "body1"}>
					{translate("importing.error_des")}
				</Typography>
				<ThemeBtn
					sx={{ mt: 6 }}
					onClick={() => window.location.reload()}
					title={translate("transfers.try_again")}
				/>
			</Box>
		</Stack>
	);
}
